"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var Press_1 = require("../components/Press/Press");
var targetNode = document.querySelector('.press-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(Press_1.default, null), targetNode);
}
